import { SelectInput } from 'react-admin';
import { OVERRIDE_CHOICES } from './constants';
import { OverrideInputProps } from './types';

const OverrideInput = ({ label = 'Override surface logic', source, ...props }: OverrideInputProps) => {
  return <SelectInput label={label} choices={OVERRIDE_CHOICES} optionValue="name" source={source} {...props} />;
};

export default OverrideInput;
